// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"lT","cardContent":"lU","editButton":"lV","innerHeading":"lW","header":"lX","subHeader":"lY"};